export const getSlugFromHashtag = (hashtag: string): string => {
    return hashtag.replace('test_', '').replace(/_/g, '-');
};
